import { useState, useEffect, useRef } from 'react';
import './Character.css';
import character from '../../images/character/1.png';
import face1 from '../../images/character/face/1.png';
import face2 from '../../images/character/face/2.png';
import face3 from '../../images/character/face/3.png';
import face4 from '../../images/character/face/4.png';
import face5 from '../../images/character/face/5.png';

const faces = [face1, face2, face3, face4, face5];

const messages = [
    "hey there!",
    "let's collab!",
    "don't be shy :)",
    "you like my glasses?",
    "lets grab coffee?",
];

const ouchMessages = [
    "ouch.",
    "ow!!",
    "STOP.",
    "i said STOP.",
    "ok that's it.",
    "i'm calling HR.",
];

function Character() {
    const [faceIndex, setFaceIndex] = useState(0);
    const [displayed, setDisplayed] = useState('');
    const [msgIndex, setMsgIndex] = useState(0);
    const [typing, setTyping] = useState(true);
    const [ouchCount, setOuchCount] = useState(0);
    const [interrupted, setInterrupted] = useState(false);
    const timeoutRef = useRef(null);
    const resumeRef = useRef(null);

    // Cycle glasses
    useEffect(() => {
        const interval = setInterval(() => {
            setFaceIndex(i => (i + 1) % faces.length);
        }, 1800);
        return () => clearInterval(interval);
    }, []);

    // Typewriter effect
    useEffect(() => {
        if (interrupted) return;
        const msg = messages[msgIndex];

        if (typing) {
            if (displayed.length < msg.length) {
                timeoutRef.current = setTimeout(() => {
                    setDisplayed(msg.slice(0, displayed.length + 1));
                }, 60);
            } else {
                timeoutRef.current = setTimeout(() => setTyping(false), 1800);
            }
        } else {
            if (displayed.length > 0) {
                timeoutRef.current = setTimeout(() => {
                    setDisplayed(d => d.slice(0, -1));
                }, 30);
            } else {
                setMsgIndex(i => (i + 1) % messages.length);
                setTyping(true);
            }
        }

        return () => clearTimeout(timeoutRef.current);
    }, [displayed, typing, msgIndex, interrupted]);

    const handlePoke = () => {
        clearTimeout(timeoutRef.current);
        clearTimeout(resumeRef.current);

        const index = Math.min(ouchCount, ouchMessages.length - 1);
        setOuchCount(c => c + 1);
        setInterrupted(true);
        setDisplayed(ouchMessages[index]);

        resumeRef.current = setTimeout(() => {
            setDisplayed('');
            setTyping(true);
            setInterrupted(false);
        }, 1500);
    };

    return (
        <>
            <div className="character-container">
                <div className="speech-bubble">
                    <span>{displayed}</span>
                    <span className="cursor">▮</span>
                </div>
                <div className="character-wrapper" onClick={handlePoke}>
                    <img src={character} alt="Pixel character" className="character-base" />
                    <img src={faces[faceIndex]} alt="Glasses" className="character-face" />
                </div>
            </div>
        </>
    );
}

export default Character;
